/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconPlus extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "PlusIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' viewBox="0 0 98.712502 98.711258" ><g id="layer1" transform="translate(-45.015896,-89.40745)"><path fill="none" stroke="#ffffff" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-dasharray="none" stroke-opacity="1" d="M 52.515896,138.76308 H 136.2284" id="path10"></path><path fill="none" stroke="#ffffff" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" stroke-dasharray="none" stroke-opacity="1" d="m 94.600283,96.90745 -0.45627,83.71126" id="path10-3"></path></g></svg>
    `;
}
